module.exports = __webpack_public_path__ + "static/media/totoro.66447e6b.jpg";